import React from "react";

import {
    PageHeader,
    Panel,
} from "../../components/ui/AdminUI";

import GeoFencePage from "../GeoFencePage";

export default function GeoFenceEmployeePage() {
    return (
        <div className="space-y-6">

            <PageHeader
                title="GeoFence Monitoring"
                subtitle="Monitor shipment geofence zones, route compliance and location events."
            />

            <Panel>
                <GeoFencePage />
            </Panel>

        </div>
    );
}